import { styled } from "@mui/material/styles";
import { Box, Typography, CardMedia, CardContent } from "@mui/material";

export const CarouselContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "85%",
  margin: "0 auto",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    maxWidth: "95%",
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    padding: theme.spacing(1),
  },
}));

export const CarouselTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  fontWeight: "bold",
  color: "#2c3e50",
  marginBottom: "12px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

export const SubRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "10px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px",
  },
  [theme.breakpoints.down("xs")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const SubCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(1.5),
  borderRadius: "8px",
  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
  height: "100%",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
  },
}));

export const SubMedia = styled(CardMedia)(({ theme }) => ({
  height: "80px",
  width: "100px",
  objectFit: "contain",
  marginBottom: "8px",
  [theme.breakpoints.down("sm")]: {
    height: "60px",
    width: "80px",
  },
}));

export const SubContent = styled(CardContent)(({ theme }) => ({
  padding: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const ProductName = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "0.85rem",
  color: "#333",
  marginBottom: "2px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
}));

export const ProductBrand = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: "#555",
  marginBottom: "2px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.7rem",
  },
}));

export const ProductPrice = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "0.85rem",
  color: "#1976d2",
  marginBottom: "2px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
}));

export const ProductPartNumber = styled(Typography)(({ theme }) => ({
  fontSize: "0.7rem",
  color: "#888",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.65rem",
  },
}));

export const DotsContainer = styled(Box)(({ theme }) => ({
  marginTop: "16px",
  display: "flex",
  justifyContent: "center",
  gap: "6px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "10px",
    gap: "4px",
  },
}));

export const Dot = styled(Box)(({ active, theme }) => ({
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: active ? "#1976d2" : "#ccc",
  cursor: "pointer",
  [theme.breakpoints.down("sm")]: {
    width: "8px",
    height: "8px",
  },
}));
